import { isEmpty } from 'lodash/fp'

import { fetchChannelPartnerPrivateOffers } from '../../../api/marketplace/index'
import type { ChannelPartnerPrivateOffersListResponse } from '../types'

export const processChannelPartnerPrivateOffers = async (
  partnerId: string,
  pageSize: number,
  pageNumber: number,
  crmOpportunityId?: string,
  input?: string,
  selectedInput?: string,
  sectionName?: string,
  selectedResellerAuth?: string
) => {
  if (isEmpty(input)) {
    const cppoResponse = await fetchChannelPartnerPrivateOffers(
      partnerId,
      pageSize,
      pageNumber,
      'created_at',
      'desc',
      crmOpportunityId,
      '',
      selectedResellerAuth
    )
    return {
      data: cppoResponse.data as ChannelPartnerPrivateOffersListResponse,
    }
  } else {
    // placeholder for search functionality
    return { data: null }
  }
}
